
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
  },
})
export default class IntroButton extends Vue {
  public showLogo = false;
  public bigLogo = false;

  mounted() {
    this.showLogo = true;
    this.bigLogo = false;
  }

  get logoDisplay() {
    // return "block";
    return this.showLogo ? "block" : "none";
  }

  get logoScale() {
    return 1;
    // return this.bigLogo ? 1.2 : 1;
  }

  romboClicked() {
    this.showLogo = false;
    this.$emit("rombo-clicked")
  }

}
